export default __webpack_public_path__ + "static/OlehKhalin-6250fa21389f8507a066943b728d4fb7.jpg";